import { activitySelectors, createAppSelector, pageSelectors, selectCurrentPageId } from "./base";

import { PageType } from "components/server-types";
import type { RootState } from "store";
import { isUnassessablePage } from "utils/page-utils";

export const selectIsUnassessablePage = createAppSelector(
  [
    (_state, page: PageType | null | undefined) => page,
    (state, page: PageType | null | undefined) =>
      page?.activity_id ? activitySelectors.selectById(state, page.activity_id) : null,
  ],
  (page, activity) => isUnassessablePage(page, activity?.category),
);

export const selectCurrentPage = createAppSelector(
  [selectCurrentPageId, pageSelectors.selectEntities],
  (pageId, pages) => (pageId && pageId in pages ? pages[pageId] : null),
);

export const selectWorksheetIdByPage = (state: RootState, pageId: string | null) =>
  pageSelectors.selectById(state, pageId)?.worksheet_id ?? null;

export const selectPageIdByWorksheetId = createAppSelector(
  [pageSelectors.selectAll, (state, worksheetId: string) => worksheetId],
  (pages, worksheetId) => {
    return pages.find((page) => page.worksheet_id === worksheetId)?.id ?? null;
  },
);
